// // Home.js
// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import './Home.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css';


// import {
//   FaSearch,
//   FaUserPlus,
//   FaStar,
//   FaGlobe,
//   FaMobileAlt,
//   FaHeadset,
//   FaShieldAlt,
//   FaFingerprint,
//   FaLaptopCode,
// } from 'react-icons/fa';
// import {
//   SiReact,
//   SiNodedotjs,
//   SiMongodb,
//   SiPython,
//   SiDocker,
//   SiFirebase,
//   SiGithub,
//   SiNextdotjs,
//   SiTypescript,
//   SiJavascript,
//   SiHtml5,
//   SiCss3,
//   SiRedux,
//   SiTailwindcss,
//   SiGraphql,
//   SiPostgresql,
//   SiMysql,
//   SiRedis,
//   SiGooglecloud,         // keep GCP
//   SiKubernetes,
//   SiNginx,
//   SiGit,
//   SiJest,
//   SiCypress,
//   SiPrisma,
//   SiNestjs,
//   SiExpress,
//   SiVite,
//   SiWebpack,
//   SiFlutter,
//   SiDart,
//   SiAndroid,
//   SiSwift,
//   SiPostman,
//   SiFigma,
// } from 'react-icons/si';
// import video from '../images/video.mp4';

// /* ---------------- Animated Counter (smooth + visible-once) ---------------- */
// const CounterBox = ({
//   target,
//   label,
//   active = undefined,         // if provided, parent controls when to start
//   duration = 1200,             // ms
//   startFrom = 0,
// }) => {
//   const [display, setDisplay] = useState(startFrom);
//   const hasAnimated = useRef(false);
//   const rafRef = useRef(0);
//   const startTimeRef = useRef(0);

//   const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

//   const start = useCallback(() => {
//     if (hasAnimated.current) return;
//     hasAnimated.current = true;

//     const from = startFrom;
//     const to = target;

//     const step = (ts) => {
//       if (!startTimeRef.current) startTimeRef.current = ts;
//       const elapsed = ts - startTimeRef.current;
//       const t = Math.min(1, elapsed / duration);
//       const eased = easeOutCubic(t);
//       const value = Math.round(from + (to - from) * eased);
//       setDisplay(value);
//       if (t < 1) {
//         rafRef.current = requestAnimationFrame(step);
//       }
//     };

//     rafRef.current = requestAnimationFrame(step);
//   }, [duration, startFrom, target]);

//   // Parent-controlled start
//   useEffect(() => {
//     if (active === true) start();
//     return () => cancelAnimationFrame(rafRef.current);
//   }, [active, start]);

//   // Fallback self-observe if no 'active' prop
//   const selfRef = useRef(null);
//   useEffect(() => {
//     if (active !== undefined) return; // parent controls
//     const obs = new IntersectionObserver(
//       ([entry]) => entry.isIntersecting && start(),
//       { threshold: 0.6 }
//     );
//     if (selfRef.current) obs.observe(selfRef.current);
//     return () => obs.disconnect();
//   }, [active, start]);

//   return (
//     <div className="counter-box" ref={selfRef}>
//       <h3>{display.toLocaleString()}+</h3>
//       <p>{label}</p>
//     </div>
//   );
// };

// const TECH = [
//   // Web & UI
//   { C: SiReact, name: 'React' },
//   { C: SiNextdotjs, name: 'Next.js' },
//   { C: SiRedux, name: 'Redux' },
//   { C: SiTailwindcss, name: 'Tailwind CSS' },
//   { C: SiJavascript, name: 'JavaScript' },
//   { C: SiTypescript, name: 'TypeScript' },
//   { C: SiHtml5, name: 'HTML5' },
//   { C: SiCss3, name: 'CSS3' },

//   // Mobile
//   { C: SiReact, name: 'React Native' },
//   { C: SiFlutter, name: 'Flutter' },
//   { C: SiDart, name: 'Dart' },
//   { C: SiAndroid, name: 'Android' },
//   { C: SiSwift, name: 'Swift' },

//   // Backend & APIs
//   { C: SiNodedotjs, name: 'Node.js' },
//   { C: SiExpress, name: 'Express' },
//   { C: SiNestjs, name: 'NestJS' },
//   { C: SiGraphql, name: 'GraphQL' },
//   { C: SiPython, name: 'Python' },

//   // Databases & Cache & ORM
//   { C: SiPostgresql, name: 'PostgreSQL' },
//   { C: SiMysql, name: 'MySQL' },
//   { C: SiMongodb, name: 'MongoDB' },
//   { C: SiRedis, name: 'Redis' },
//   { C: SiPrisma, name: 'Prisma' },

//   // Cloud & Infra & DevOps
//   { C: SiGooglecloud, name: 'Google Cloud' },
//   { C: SiDocker, name: 'Docker' },
//   { C: SiKubernetes, name: 'Kubernetes' },
//   { C: SiNginx, name: 'Nginx' },

//   // Tooling & QA & Collab
//   { C: SiVite, name: 'Vite' },
//   { C: SiWebpack, name: 'Webpack' },
//   { C: SiJest, name: 'Jest' },
//   { C: SiCypress, name: 'Cypress' },
//   { C: SiPostman, name: 'Postman' },
//   { C: SiGit, name: 'Git' },
//   { C: SiGithub, name: 'GitHub' },
//   { C: SiFirebase, name: 'Firebase' },
//   { C: SiFigma, name: 'Figma' },
// ];


// const Home = () => {
//   // AOS init
//   useEffect(() => {
//     AOS.init({ duration: 1200, once: true });
//   }, []);

//   // Observe the "Our Impact" section; fire once when ~60% visible
//   const impactRef = useRef(null);
//   const [impactInView, setImpactInView] = useState(false);

//   useEffect(() => {
//     const obs = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setImpactInView(true);
//           obs.disconnect();
//         }
//       },
//       {
//         threshold: 0.6,
//         root: null,
//         rootMargin: '0px 0px -10% 0px', // slight buffer so it starts mid-section
//       }
//     );
//     if (impactRef.current) obs.observe(impactRef.current);
//     return () => obs.disconnect();
//   }, []);

//   return (
//     <div className="home-container">
//       {/* ============= Hero ============= */}
//       <header className="hero-section">
//         <video className="home-video" autoPlay muted loop playsInline>
//           <source src={video} type="video/mp4" />
//         </video>

//         <div className="overlay">
//           <h1 className="title" data-aos="fade-down">
//             <span className="title-prefix">Welcome to</span>
//             <span
//               className="brand-zoom"
//               aria-label="Aazira Solutions Private Limited"
//             >
//               Aazira Solutions Pvt. Ltd.
//             </span>
//           </h1>

//           <p className="subtitle" data-aos="fade-up">
//             Transforming ideas into powerful digital Solutions.
//           </p>

//           <div className="cta-buttons" data-aos="zoom-in">
//             <button className="btn primary-btn">
//               <FaUserPlus aria-hidden="true" />
//               &nbsp; Join Now
//             </button>
//             <button className="btn secondary-btn">
//               <FaSearch aria-hidden="true" />
//               &nbsp; Explore
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* ============= Features ============= */}
//       <section className="features-section">
//         <div className="container">
//           <h2 className="gradient-text" data-aos="fade-down">
//             Why Choose Aazira Technology?
//           </h2>

//           <p className="features-intro" data-aos="fade-up">
//             We’re a friendly, full-stack team building <strong>web apps</strong>,{' '}
//             <strong>Android apps</strong>, and modern <strong>websites</strong>.
//             You’ll get <strong>24/7 support</strong>, strong <strong>security</strong> built in, and{' '}
//             <strong>original content</strong> that fits your brand.
//           </p>

//           <div className="features-grid">
//             {/* Web Apps */}
//             <div className="feature pro-card" data-aos="fade-up">
//               <div className="feature-ribbon">End-to-End</div>
//               <div className="icon-wrap">
//                 <FaLaptopCode className="feature-icon" />
//               </div>
//               <h3>Custom Web Apps</h3>
//               <p>We build clean, fast apps that match how your business actually works.</p>
//               <ul className="feature-list">
//                 <li>Easy to use, easy to scale</li>
//                 <li>Works great on all devices</li>
//                 <li>Loads quickly and feels smooth</li>
//               </ul>
//             </div>

//             {/* Android Apps */}
//             <div className="feature pro-card" data-aos="fade-up" data-aos-delay="80">
//               <div className="badge chip">Play Store Ready</div>
//               <div className="icon-wrap">
//                 <FaMobileAlt className="feature-icon" />
//               </div>
//               <h3>Android App Development</h3>
//               <p>From idea to launch — reliable apps that customers love to use.</p>
//               <ul className="feature-list">
//                 <li>Works offline with smart sync</li>
//                 <li>Secure login and payments</li>
//                 <li>Battery-friendly & crash-safe</li>
//               </ul>
//             </div>

//             {/* Websites */}
//             <div className="feature pro-card" data-aos="fade-up" data-aos-delay="160">
//               <div className="badge chip">SEO + Speed</div>
//               <div className="icon-wrap">
//                 <FaGlobe className="feature-icon" />
//               </div>
//               <h3>Websites that Convert</h3>
//               <p>Beautiful, responsive sites that are easy to find and simple to manage.</p>
//               <ul className="feature-list">
//                 <li>Fast loading & SEO-friendly</li>
//                 <li>CMS or headless — your choice</li>
//                 <li>Pixel-perfect, accessible design</li>
//               </ul>
//             </div>

//             {/* 24/7 Support */}
//             <div className="feature pro-card" data-aos="fade-up" data-aos-delay="240">
//               <div className="badge chip success">24/7</div>
//               <div className="icon-wrap">
//                 <FaHeadset className="feature-icon" />
//               </div>
//               <h3>Always-On Support</h3>
//               <p>We’re here whenever you need us — no long waits, just quick help.</p>
//               <ul className="feature-list">
//                 <li>Dedicated success manager</li>
//                 <li>On-call engineers</li>
//                 <li>Clear, regular updates</li>
//               </ul>
//             </div>

//             {/* Security */}
//             <div className="feature pro-card" data-aos="fade-up" data-aos-delay="320">
//               <div className="badge chip warn">Security-First</div>
//               <div className="icon-wrap">
//                 <FaShieldAlt className="feature-icon" />
//               </div>
//               <h3>Secure by Design</h3>
//               <p>Protection from day one — safe data, safe users, safe business.</p>
//               <ul className="feature-list">
//                 <li>OWASP-based reviews</li>
//                 <li>Roles, permissions & audit logs</li>
//                 <li>Encryption in transit & at rest</li>
//               </ul>
//             </div>

//             {/* Unique Content */}
//             <div className="feature pro-card" data-aos="fade-up" data-aos-delay="400">
//               <div className="badge chip info">Brand-Unique</div>
//               <div className="icon-wrap">
//                 <FaFingerprint className="feature-icon" />
//               </div>
//               <h3>Unique Content & UX</h3>
//               <p>Clear words and thoughtful design that feel like your brand.</p>
//               <ul className="feature-list">
//                 <li>Simple, persuasive copy</li>
//                 <li>Reusable design system</li>
//                 <li>Tested with real users</li>
//               </ul>
//             </div>
//           </div>

//           <div className="features-meta" data-aos="fade-up" data-aos-delay="460">
//             <span className="meta-pill">
//               <FaSearch /> Latest Tech: AI · Cloud · DevOps
//             </span>
//             <span className="meta-pill">
//               <FaStar /> Quality + Innovation Every Release
//             </span>
//             <span className="meta-pill">
//               <FaUserPlus /> Client-Centric, Transparent Delivery
//             </span>
//           </div>
//         </div>
//       </section>

//       {/* ============= Impact Counters ============= */}
//       <section className="counter-section" data-aos="fade-up" ref={impactRef}>
//         <div className="container">
//           <h2 className="gradient-text">Our Impact</h2>
//           <div className="counter-grid">
//             <CounterBox target={3}  label="Projects Delivered"   active={impactInView} duration={1200} />
//             <CounterBox target={3}  label="Happy Clients"        active={impactInView} duration={1200} />
//             <CounterBox target={10} label="Years of Experience"  active={impactInView} duration={1200} />
//           </div>
//         </div>
//       </section>

//       {/* ============= Tech Carousel ============= */}
//       <section className="tech-carousel-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">Technologies We Use</h2>
//           <div className="carousel-wrapper" aria-label="Technology logos">
//             {/* <div className="carousel-track">
//               {[0, 1].map((loop) =>
//                 TECH.map(({ C, name }, i) => (
//                   <C className="tech-icon" title={name} key={`${name}-${loop}-${i}`} />
//                 ))
//               )}
//             </div> */}
//             <div className="carousel-track">
//               {[0, 1].map((loop) =>
//               TECH.map(({ C, name }, i) => (
//               <span className="tech-item" data-label={name} key={`${name}-${loop}-${i}`}>
//                 <C className="tech-icon" aria-label={name} title={name} size={44} />
//                 </span>
//                 ))
//                 )}
//                 </div>
//                 </div>
//                 </div>
//       </section>

//       {/* ============= Testimonial ============= */}
//       <section className="testimonial-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">What Our Clients Say</h2>
//         <div className="testimonial-card">
//             <p>
//               “Aazira Solutions turned our vision into reality. Their attention to detail,
//               dedication, and expert Solutions were beyond expectations.”
//             </p>
//             <h4 className="testimonial-author">— Pratik Barge</h4>
//           </div>
//         </div>
//       </section>

//       {/* ============= Services ============= */}
//       <section className="services-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">Our Core Services</h2>
//           <div className="tab-content">
//             <p>
//               At <strong>Aazira Solutions Pvt. Ltd.</strong>, creation and innovation are
//               at the heart of everything we do. We transform bold ideas into powerful
//               digital realities with craftsmanship and modern engineering.
//             </p>
//             <p>
//               From intuitive user experiences to scalable platforms, our team blends
//               product thinking with deep technical expertise to build what’s next.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* ============= Process ============= */}
//       <section className="process-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">Our Process</h2>

//           <ol className="process-steps">
//             <li className="process-step">
//               <div className="step-dot" /><h3>Discover</h3>
//               <p>Workshops to align goals, users, scope, and success metrics.</p>
//             </li>
//             <li className="process-step">
//               <div className="step-dot" /><h3>Design</h3>
//               <p>Wireframes, flows, and UI prototypes that validate early.</p>
//             </li>
//             <li className="process-step">
//               <div className="step-dot" /><h3>Build</h3>
//               <p>Sprint-based development with CI/CD and code reviews.</p>
//             </li>
//             <li className="process-step">
//               <div className="step-dot" /><h3>Test</h3>
//               <p>Automation + manual QA, performance and security checks.</p>
//             </li>
//             <li className="process-step">
//               <div className="step-dot" /><h3>Launch & Scale</h3>
//               <p>Observability, SLAs, and iterative growth post-launch.</p>
//             </li>
//           </ol>
//         </div>
//       </section>

//       {/* ============= Recent Work ============= */}
//       <section className="work-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">Recent Work</h2>

//           <div className="work-grid">
//             {/* Case 1: Match-Making */}
//             <article className="work-card">
//               <div className="work-badge">D2C • Social</div>
//               <h3>AI Match-Making App</h3>
//               <p>
//                 AI-powered dating with verified profiles and ranked suggestions for safer,
//                 more compatible matches.
//               </p>
//               <ul className="work-points">
//                 <li>↑ 31% match-to-chat conversion</li>
//                 <li>↓ 42% fake/abuse reports via liveness + ID</li>
//                 <li>Realtime chat, media share, travel mode</li>
//               </ul>
//               <div className="work-tags">
//                 <span>React Native</span><span>Node</span><span>PostgreSQL</span>
//                 <span>AWS</span>
//               </div>
//             </article>

//             {/* Case 2: Healthcare */}
//             <article className="work-card">
//               <div className="work-badge">HealthTech</div>
//               <h3>Tele-Consult & e-Prescription</h3>
//               <p>
//                 Secure video consults, e-prescriptions, and clinic workflows with audit logs
//                 and role-based access.
//               </p>
//               <ul className="work-points">
//                 <li>10k+ monthly consults at peak</li>
//                 <li>Payments, invoices, follow-up reminders</li>
//                 <li>eRx & lab orders with compliance checks</li>
//               </ul>
//               <div className="work-tags">
//                 <span>Next.js</span><span>WebRTC</span><span>FastAPI</span>
//                 <span>PostgreSQL</span><span>AWS</span>
//               </div>
//             </article>

//             {/* Case 3: E-commerce */}
//             <article className="work-card">
//               <div className="work-badge">Retail • D2C</div>
//               <h3>PWA Storefront & OMS</h3>
//               <p>
//                 Conversion-focused storefront with fast checkout and a robust order &
//                 inventory backend.
//               </p>
//               <ul className="work-points">
//                 <li>↑ 22% checkout completion</li>
//                 <li>Multi-warehouse routing & low-stock alerts</li>
//                 <li>GST invoicing, Shiprocket & WhatsApp updates</li>
//               </ul>
//               <div className="work-tags">
//                 <span>Next.js</span><span>NestJS</span><span>PostgreSQL</span>
//                 <span>Elasticsearch</span><span>Stripe/Razorpay</span>
//               </div>
//             </article>
//           </div>
//         </div>
//       </section>

//       {/* ============= Engagement Models ============= */}
//       <section className="engagement-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">Engagement Models</h2>

//           <div className="engage-grid">
//             {/* Fixed-Price */}
//             <div className="engage-card">
//               <h3>Fixed-Price</h3>
//               <p className="engage-tag">Best for: MVPs, PoCs, well-defined scope</p>
//               <ul className="engage-list">
//                 <li>Upfront scope, milestones, and acceptance criteria</li>
//                 <li>Delivery-based payments, no hidden costs</li>
//                 <li>Our risk on schedule/cost overruns within scope</li>
//                 <li>Weekly demos, QA sign-offs, and UAT windows</li>
//               </ul>
//               <div className="engage-meta">
//                 <strong>SLA:</strong> timeline & quality gates • <strong>Billing:</strong> milestone-wise
//               </div>
//             </div>

//             {/* Time & Material */}
//             <div className="engage-card">
//               <h3>Time & Material</h3>
//               <p className="engage-tag">Best for: evolving products & discovery-led work</p>
//               <ul className="engage-list">
//                 <li>Flexible, prioritized backlog with rolling sprints</li>
//                 <li>Transparent timesheets and burn-down reports</li>
//                 <li>Pivot quickly as assumptions change</li>
//                 <li>Optional monthly cap to control spend</li>
//               </ul>
//               <div className="engage-meta">
//                 <strong>SLA:</strong> sprint commitments • <strong>Billing:</strong> hourly/monthly
//               </div>
//             </div>

//             {/* Dedicated Team */}
//             <div className="engage-card">
//               <h3>Dedicated Team</h3>
//               <p className="engage-tag">Best for: long-term roadmaps & steady velocity</p>
//               <ul className="engage-list">
//                 <li>Exclusive pod: PM/BA, Designers, Engineers, QA/DevOps</li>
//                 <li>Roadmap ownership with OKRs and release cadence</li>
//                 <li>Hands-on collaboration with your internal team</li>
//                 <li>Knowledge retention and lower ramp-up costs</li>
//               </ul>
//               <div className="engage-meta">
//                 <strong>SLA:</strong> velocity & availability • <strong>Billing:</strong> monthly retainer
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ============= FAQ ============= */}
//       <section className="faq-section" data-aos="fade-up">
//         <div className="container">
//           <h2 className="gradient-text">FAQs</h2>
//           <div className="faq-list">
//             <details>
//               <summary>How fast can we start?</summary>
//               <p>Discovery can start within 3–5 business days. Build usually begins the following sprint.</p>
//             </details>
//             <details>
//               <summary>Do you sign NDAs and SLAs?</summary>
//               <p>Yes—mutual NDA, IP assignment, and support SLAs are standard practice.</p>
//             </details>
//             <details>
//               <summary>Which domains do you specialize in?</summary>
//               <p>FinTech, HealthTech, Retail, and SaaS platforms—plus integrations with major clouds and payment gateways.</p>
//             </details>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;





// Home.js
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Home.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import {
  FaSearch,
  FaUserPlus,
  FaStar,
  FaGlobe,
  FaMobileAlt,
  FaHeadset,
  FaShieldAlt,
  FaFingerprint,
  FaLaptopCode,
  FaListUl,
  FaPencilRuler,
  FaFlask,
  FaCloudUploadAlt,
  FaRocket,
} from 'react-icons/fa';
import {
  SiReact,
  SiNodedotjs,
  SiMongodb,
  SiPython,
  SiDocker,
  SiFirebase,
  SiGithub,
  SiNextdotjs,
  SiTypescript,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiRedux,
  SiTailwindcss,
  SiGraphql,
  SiPostgresql,
  SiMysql,
  SiRedis,
  SiGooglecloud,         // keep GCP
  SiKubernetes,
  SiNginx,
  SiGit,
  SiJest,
  SiCypress,
  SiPrisma,
  SiNestjs,
  SiExpress,
  SiVite,
  SiWebpack,
  SiFlutter,
  SiDart,
  SiAndroid,
  SiSwift,
  SiPostman,
  SiFigma,
} from 'react-icons/si';
import video from '../images/video.mp4';

/* ---------------- Animated Counter (smooth + visible-once) ---------------- */
const CounterBox = ({
  target,
  label,
  active = undefined,         // if provided, parent controls when to start
  duration = 1200,             // ms
  startFrom = 0,
}) => {
  const [display, setDisplay] = useState(startFrom);
  const hasAnimated = useRef(false);
  const rafRef = useRef(0);
  const startTimeRef = useRef(0);

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const start = useCallback(() => {
    if (hasAnimated.current) return;
    hasAnimated.current = true;

    const from = startFrom;
    const to = target;

    const step = (ts) => {
      if (!startTimeRef.current) startTimeRef.current = ts;
      const elapsed = ts - startTimeRef.current;
      const t = Math.min(1, elapsed / duration);
      const eased = easeOutCubic(t);
      const value = Math.round(from + (to - from) * eased);
      setDisplay(value);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(step);
      }
    };

    rafRef.current = requestAnimationFrame(step);
  }, [duration, startFrom, target]);

  // Parent-controlled start
  useEffect(() => {
    if (active === true) start();
    return () => cancelAnimationFrame(rafRef.current);
  }, [active, start]);

  // Fallback self-observe if no 'active' prop
  const selfRef = useRef(null);
  useEffect(() => {
    if (active !== undefined) return; // parent controls
    const obs = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && start(),
      { threshold: 0.6 }
    );
    if (selfRef.current) obs.observe(selfRef.current);
    return () => obs.disconnect();
  }, [active, start]);

  return (
    <div className="counter-box" ref={selfRef}>
      <h3>{display.toLocaleString()}+</h3>
      <p>{label}</p>
    </div>
  );
};

const TECH = [
  // Web & UI
  { C: SiReact, name: 'React' },
  { C: SiNextdotjs, name: 'Next.js' },
  { C: SiRedux, name: 'Redux' },
  { C: SiTailwindcss, name: 'Tailwind CSS' },
  { C: SiJavascript, name: 'JavaScript' },
  { C: SiTypescript, name: 'TypeScript' },
  { C: SiHtml5, name: 'HTML5' },
  { C: SiCss3, name: 'CSS3' },

  // Mobile
  { C: SiReact, name: 'React Native' },
  { C: SiFlutter, name: 'Flutter' },
  { C: SiDart, name: 'Dart' },
  { C: SiAndroid, name: 'Android' },
  { C: SiSwift, name: 'Swift' },

  // Backend & APIs
  { C: SiNodedotjs, name: 'Node.js' },
  { C: SiExpress, name: 'Express' },
  { C: SiNestjs, name: 'NestJS' },
  { C: SiGraphql, name: 'GraphQL' },
  { C: SiPython, name: 'Python' },

  // Databases & Cache & ORM
  { C: SiPostgresql, name: 'PostgreSQL' },
  { C: SiMysql, name: 'MySQL' },
  { C: SiMongodb, name: 'MongoDB' },
  { C: SiRedis, name: 'Redis' },
  { C: SiPrisma, name: 'Prisma' },

  // Cloud & Infra & DevOps
  { C: SiGooglecloud, name: 'Google Cloud' },
  { C: SiDocker, name: 'Docker' },
  { C: SiKubernetes, name: 'Kubernetes' },
  { C: SiNginx, name: 'Nginx' },

  // Tooling & QA & Collab
  { C: SiVite, name: 'Vite' },
  { C: SiWebpack, name: 'Webpack' },
  { C: SiJest, name: 'Jest' },
  { C: SiCypress, name: 'Cypress' },
  { C: SiPostman, name: 'Postman' },
  { C: SiGit, name: 'Git' },
  { C: SiGithub, name: 'GitHub' },
  { C: SiFirebase, name: 'Firebase' },
  { C: SiFigma, name: 'Figma' },
];

/* ---------------- Testimonials (added) ---------------- */
const TESTIMONIALS = [
  {
    name: "Pratik Barge",
    role: "",
    quote:
      "Aazira Solutions turned our vision into reality. Their attention to detail, dedication, and expert solutions were beyond expectations.",
    avatar:
      "https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=200&auto=format&fit=facearea&facepad=3&h=200",
  },
  {
    name: "Riya Sharma",
    role: "",
    quote:
      "Fast, transparent, and deeply collaborative. We shipped a complex tele-consult product on time—and the quality bar was stellar.",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=facearea&facepad=3&h=200",
  },
  {
    name: "Aarav Mehta",
    role: "",
    quote:
      "Our website finally works the way we work. Updating products takes minutes, and we’re getting more orders from mobile. The team was clear, friendly, and kept us in the loop.",
    avatar:
      "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?q=80&w=200&auto=format&fit=facearea&facepad=3&h=200",
  },
];

const TestimonialCarousel = () => {
  const [index, setIndex] = useState(0);
  const size = TESTIMONIALS.length;
  const wrap = (i) => (i + size) % size;

  const goTo = (i) => setIndex(wrap(i));
  const next = () => setIndex((i) => wrap(i + 1));
  const prev = () => setIndex((i) => wrap(i - 1));

  // autoplay with pause on hover
  const timerRef = useRef(null);
  const hostRef = useRef(null);

  useEffect(() => {
    const start = () => {
      if (timerRef.current) return;
      timerRef.current = setInterval(next, 5000);
    };
    const stop = () => {
      if (!timerRef.current) return;
      clearInterval(timerRef.current);
      timerRef.current = null;
    };

    start();
    const node = hostRef.current;
    node?.addEventListener("mouseenter", stop);
    node?.addEventListener("mouseleave", start);

    return () => {
      clearInterval(timerRef.current);
      timerRef.current = null;
      node?.removeEventListener("mouseenter", stop);
      node?.removeEventListener("mouseleave", start);
    };
  }, []);

  // swipe support
  const touch = useRef({ x: 0, y: 0, t: 0 });
  const onTouchStart = (e) => {
    const t = e.touches[0];
    touch.current = { x: t.clientX, y: t.clientY, t: Date.now() };
  };
  const onTouchEnd = (e) => {
    const dx = (e.changedTouches?.[0]?.clientX || 0) - touch.current.x;
    const dy = (e.changedTouches?.[0]?.clientY || 0) - touch.current.y;
    const dt = Date.now() - touch.current.t;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && dt < 800) {
      dx < 0 ? next() : prev();
    }
  };

  // keyboard arrows
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div
      className="t-carousel"
      ref={hostRef}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <button className="t-arrow left" aria-label="Previous" onClick={prev}>
        ‹
      </button>

      <div className="t-viewport" aria-live="polite">
        <div
          className="t-track"
          style={{ transform: `translateX(calc(-${index} * 100%))` }}
        >
          {TESTIMONIALS.map((t, i) => (
            <figure className="t-card" key={t.name + i}>
              <div className="t-ring" />
              <div className="t-quote-mark" aria-hidden="true">“</div>

              <img
                className="t-avatar"
                src={t.avatar}
                alt={`${t.name} avatar`}
                loading="lazy"
              />
              <blockquote className="t-quote">{t.quote}</blockquote>
              <figcaption className="t-meta">
                <span className="t-name">{t.name}</span>
                <span className="t-role">{t.role}</span>
                <div className="t-stars" aria-label="5 stars">
                  ★★★★★
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      <button className="t-arrow right" aria-label="Next" onClick={next}>
        ›
      </button>

      <div className="t-dots" role="tablist" aria-label="Testimonials">
        {TESTIMONIALS.map((_, i) => (
          <button
            key={i}
            role="tab"
            aria-selected={i === index}
            className={`t-dot ${i === index ? "active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </div>
  );
};

const Home = () => {
  // AOS init
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  // Observe the "Our Impact" section; fire once when ~60% visible
  const impactRef = useRef(null);
  const [impactInView, setImpactInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setImpactInView(true);
          obs.disconnect();
        }
      },
      {
        threshold: 0.6,
        root: null,
        rootMargin: '0px 0px -10% 0px', // slight buffer so it starts mid-section
      }
    );
    if (impactRef.current) obs.observe(impactRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="home-container">
      {/* ============= Hero ============= */}
      <header className="hero-section">
        <video className="home-video" autoPlay muted loop playsInline>
          <source src={video} type="video/mp4" />
        </video>

        <div className="overlay">
          <h1 className="title" data-aos="fade-down">
            <span className="title-prefix">Welcome to</span>
            <span
              className="brand-zoom"
              aria-label="Aazira Solutions Private Limited"
            >
              Aazira Solutions Pvt. Ltd.
            </span>
          </h1>

          <p className="subtitle" data-aos="fade-up">
            Transforming ideas into powerful digital Solutions.
          </p>

          <div className="cta-buttons" data-aos="zoom-in">
            <button className="btn primary-btn">
              <FaUserPlus aria-hidden="true" />
              &nbsp; Join Now
            </button>
            <button className="btn secondary-btn">
              <FaSearch aria-hidden="true" />
              &nbsp; Explore
            </button>
          </div>
        </div>
      </header>

      {/* ============= Features ============= */}
      <section className="features-section">
        <div className="container">
          <h2 className="gradient-text" data-aos="fade-down">
            Why Choose Aazira Technology?
          </h2>

        <p className="features-intro" data-aos="fade-up">
            We’re a friendly, full-stack team building <strong>web apps</strong>,{' '}
            <strong>Android apps</strong>, and modern <strong>websites</strong>.
            You’ll get <strong>24/7 support</strong>, strong <strong>security</strong> built in, and{' '}
            <strong>original content</strong> that fits your brand.
          </p>

          <div className="features-grid">
            {/* Web Apps */}
            <div className="feature pro-card" data-aos="fade-up">
              <div className="feature-ribbon">End-to-End</div>
              <div className="icon-wrap">
                <FaLaptopCode className="feature-icon" />
              </div>
              <h3>Custom Web Apps</h3>
              <p>We build clean, fast apps that match how your business actually works.</p>
              <ul className="feature-list">
                <li>Easy to use, easy to scale</li>
                <li>Works great on all devices</li>
                <li>Loads quickly and feels smooth</li>
              </ul>
            </div>

            {/* Android Apps */}
            <div className="feature pro-card" data-aos="fade-up" data-aos-delay="80">
              <div className="badge chip">Play Store Ready</div>
              <div className="icon-wrap">
                <FaMobileAlt className="feature-icon" />
              </div>
              <h3>Android App Development</h3>
              <p>From idea to launch — reliable apps that customers love to use.</p>
              <ul className="feature-list">
                <li>Works offline with smart sync</li>
                <li>Secure login and payments</li>
                <li>Battery-friendly & crash-safe</li>
              </ul>
            </div>

            {/* Websites */}
            <div className="feature pro-card" data-aos="fade-up" data-aos-delay="160">
              <div className="badge chip">SEO + Speed</div>
              <div className="icon-wrap">
                <FaGlobe className="feature-icon" />
              </div>
              <h3>Websites that Convert</h3>
              <p>Beautiful, responsive sites that are easy to find and simple to manage.</p>
              <ul className="feature-list">
                <li>Fast loading & SEO-friendly</li>
                <li>CMS or headless — your choice</li>
                <li>Pixel-perfect, accessible design</li>
              </ul>
            </div>

            {/* 24/7 Support */}
            <div className="feature pro-card" data-aos="fade-up" data-aos-delay="240">
              <div className="badge chip success">24/7</div>
              <div className="icon-wrap">
                <FaHeadset className="feature-icon" />
              </div>
              <h3>Always-On Support</h3>
              <p>We’re here whenever you need us — no long waits, just quick help.</p>
              <ul className="feature-list">
                <li>Dedicated success manager</li>
                <li>On-call engineers</li>
                <li>Clear, regular updates</li>
              </ul>
            </div>

            {/* Security */}
            <div className="feature pro-card" data-aos="fade-up" data-aos-delay="320">
              <div className="badge chip warn">Security-First</div>
              <div className="icon-wrap">
                <FaShieldAlt className="feature-icon" />
              </div>
              <h3>Secure by Design</h3>
              <p>Protection from day one — safe data, safe users, safe business.</p>
              <ul className="feature-list">
                <li>OWASP-based reviews</li>
                <li>Roles, permissions & audit logs</li>
                <li>Encryption in transit & at rest</li>
              </ul>
            </div>

            {/* Unique Content */}
            <div className="feature pro-card" data-aos="fade-up" data-aos-delay="400">
              <div className="badge chip info">Brand-Unique</div>
              <div className="icon-wrap">
                <FaFingerprint className="feature-icon" />
              </div>
              <h3>Unique Content & UX</h3>
              <p>Clear words and thoughtful design that feel like your brand.</p>
              <ul className="feature-list">
                <li>Simple, persuasive copy</li>
                <li>Reusable design system</li>
                <li>Tested with real users</li>
              </ul>
            </div>
          </div>

          <div className="features-meta" data-aos="fade-up" data-aos-delay="460">
            <span className="meta-pill">
              <FaSearch /> Latest Tech: AI · Cloud · DevOps
            </span>
            <span className="meta-pill">
              <FaStar /> Quality + Innovation Every Release
            </span>
            <span className="meta-pill">
              <FaUserPlus /> Client-Centric, Transparent Delivery
            </span>
          </div>
        </div>
      </section>

      {/* ============= Impact Counters ============= */}
      <section className="counter-section" data-aos="fade-up" ref={impactRef}>
        <div className="container">
          <h2 className="gradient-text">Our Impact</h2>
          <div className="counter-grid">
            <CounterBox target={10}  label="Projects Delivered"   active={impactInView} duration={1200} />
            <CounterBox target={30}  label="Happy Clients"        active={impactInView} duration={1200} />
            <CounterBox target={16} label="Technologies Mastered"  active={impactInView} duration={1200} />
          </div>
        </div>
      </section>

      {/* ============= Tech Carousel ============= */}
      <section className="tech-carousel-section" data-aos="fade-up">
        <div className="container">
          <h2 className="gradient-text">Technologies We Use</h2>
          <div className="carousel-wrapper" aria-label="Technology logos">
            <div className="carousel-track">
              {[0, 1].map((loop) =>
                TECH.map(({ C, name }, i) => (
                  <span className="tech-item" data-label={name} key={`${name}-${loop}-${i}`}>
                    <C className="tech-icon" aria-label={name} title={name} size={44} />
                  </span>
                ))
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ============= Testimonial ============= */}
      <section className="testimonial-section" data-aos="fade-up">
        <div className="container">
          <h2 className="gradient-text">What Our Clients Say</h2>
          <TestimonialCarousel />
        </div>
      </section>

      {/* ============= Services ============= */}
      {/* <section className="services-section" data-aos="fade-up">
        <div className="container">
          <h2 className="gradient-text">Our Core Services</h2>
          <div className="tab-content">
            <p>
              At <strong>Aazira Solutions Pvt. Ltd.</strong>, creation and innovation are
              at the heart of everything we do. We transform bold ideas into powerful
              digital realities with craftsmanship and modern engineering.
            </p>
            <p>
              From intuitive user experiences to scalable platforms, our team blends
              product thinking with deep technical expertise to build what’s next.
            </p>
          </div>
        </div>
      </section> */}
      <div className="tab-content">
  <p>
    At <strong>Aazira Solutions Pvt. Ltd.</strong>, we help you
    <strong> build software that ships</strong> and
    <strong> marketing that converts</strong>. One team, end-to-end:
    strategy → design → build → launch → growth.
  </p>

  <div className="features-grid" style={{marginTop: '18px'}}>
    {/* Digital Marketing */}
    <div className="feature pro-card" data-aos="fade-up">
      <div className="badge chip info">Digital Marketing</div>
      <h3>Get Found. Get Clicks. Get Customers.</h3>
      <p>
        We blend content, performance ads, and analytics to grow your pipeline
        without vanity metrics. Every rupee tracked, every campaign optimised.
      </p>
      <ul className="feature-list">
        <li>SEO that ranks: tech fixes, on-page, and backlinks that last</li>
        <li>Paid ads that pay back: Google, Meta, LinkedIn & retargeting</li>
        <li>Content that sells: landing pages, blogs, emails, reels</li>
        <li>Conversion design: A/B tests, heatmaps, lead forms that work</li>
        <li>Full-funnel reporting: clear dashboards, weekly insights</li>
      </ul>
      <div className="features-meta" style={{marginTop: 12}}>
        <span className="meta-pill">↑ Higher CTR & ROAS</span>
        <span className="meta-pill">↑ Qualified Leads</span>
        <span className="meta-pill">↓ CPA & Wasted Spend</span>
      </div>
    </div>

    {/* Software Development */}
    <div className="feature pro-card" data-aos="fade-up" data-aos-delay="120">
      <div className="badge chip success">Software Development</div>
      <h3>Design. Build. Ship. Scale.</h3>
      <p>
        From MVPs to enterprise platforms, we deliver clean code, reliable
        releases, and cloud-first architecture that grows with you.
      </p>
      <ul className="feature-list">
        <li>Web & Mobile apps: React/Next.js, Node/NestJS, Flutter</li>
        <li>API & Integrations: REST/GraphQL, payments, logistics, CRM</li>
        <li>Data & Storage: PostgreSQL, MongoDB, Redis, caching & search</li>
        <li>Quality & Security: CI/CD, automated tests, OWASP best practices</li>
        <li>Cloud & DevOps: Docker/Kubernetes, GCP, monitoring & alerts</li>
      </ul>
      <div className="features-meta" style={{marginTop: 12}}>
        <span className="meta-pill">⚡ Fast + Responsive</span>
        <span className="meta-pill">🛡️ Secure by Default</span>
        <span className="meta-pill">📈 Built to Scale</span>
      </div>
    </div>
  </div>

  <p style={{marginTop: 18}}>
    Prefer a discovery call? We can review your goals, pick the quickest path
    to value, and start with a small, time-boxed milestone—so you see progress
    before big commitments.
  </p>
</div>


      {/* ============= Process ============= */}
<section className="process-section" data-aos="fade-up">
  <div className="container">
    <h2 className="gradient-text">Our Process</h2>

    <ol className="process-flow" aria-label="Project delivery steps">
      {[
        {
          title: 'Discover',
          icon: <FaSearch />,
          desc:
            'Understand your users, goals, and risks with short workshops and audits.',
        },
        {
          title: 'Requirements',
          icon: <FaListUl />,
          desc:
            'Write clear user stories, acceptance criteria, and a prioritized roadmap.',
        },
        {
          title: 'Design',
          icon: <FaPencilRuler />,
          desc:
            'Prototype key flows and UI states; validate with quick feedback loops.',
        },
        {
          title: 'Development',
          icon: <FaLaptopCode />,
          desc:
            'Ship in sprints with code reviews, branching standards, and CI/CD.',
        },
        {
          title: 'Testing',
          icon: <FaFlask />,
          desc:
            'Automated + manual QA for functionality, performance, and security.',
        },
        {
          title: 'Deployment',
          icon: <FaCloudUploadAlt />,
          desc:
            'Versioned releases, blue/green or canary rollout, monitoring + logs.',
        },
        {
          title: 'Launch & Scale',
          icon: <FaRocket />,
          desc:
            'Post-launch support, analytics-driven iterations, and capacity planning.',
        },
      ].map((s, i) => (
        <li
          className="p-step"
          key={s.title}
          data-step={i + 1}
          data-aos="fade-up"
          data-aos-delay={i * 70}
        >
          <span className="p-connector" aria-hidden="true" />
          <span className="p-arrow" aria-hidden="true" />

          <div className="p-badge" aria-hidden="true">
            <span className="p-num">{i + 1}</span>
          </div>

          <div className="p-icon">{s.icon}</div>

          {/* use fixed-height wrappers to keep titles/desc aligned */}
          <div className="p-head">
            <h3 className="p-title">{s.title}</h3>
          </div>
          <div className="p-body">
            <p className="p-desc">{s.desc}</p>
          </div>
        </li>
      ))}
    </ol>
  </div>
</section>




      {/* ============= Recent Work ============= */}
      <section className="work-section" data-aos="fade-up">
  <div className="container">
    <h2 className="gradient-text">Recent Work</h2>

    <div className="work-grid">
      {/* Case 1: Jusst Mingle – Mobile App */}
      <article className="work-card" data-aos="fade-up">
        <div className="work-badge">D2C • Social</div>
        <h3>Jusst Mingle — Dating App (iOS & Android)</h3>
        <p>
          Consumer dating app with verified profiles, real-time chat, and smart
          match suggestions. Designed for safety, speed, and a smooth onboarding.
        </p>
        <ul className="work-points">
          <li>Phone / email / ID verification & profile review</li>
          <li>Realtime chat with media, typing & read receipts</li>
          <li>Recommendation feed, likes, and match queue</li>
          <li>In-app purchases / subscriptions & push notifications</li>
          <li>Report, block, and moderation workflows</li>
        </ul>
        <div className="work-tags">
          <span>React Native</span><span>Node.js</span>
          <span>PostgreSQL (pgAdmin)</span><span>AWS</span>
        </div>
      </article>

      {/* Case 2: Jusst Mingle – Admin Web */}
      <article className="work-card" data-aos="fade-up" data-aos-delay="80">
        <div className="work-badge">Ops • Admin</div>
        <h3>Jusst Mingle — Admin Web</h3>
        <p>
          Central dashboard for moderation, analytics, and support. Role-based
          access with full audit trails and configurable policies.
        </p>
        <ul className="work-points">
          <li>User management, KYC review, refunds & escalations</li>
          <li>Content moderation queues with bulk actions</li>
          <li>Metrics: growth, retention, revenue, and funnels</li>
          <li>CMS for banners, pricing, and feature flags</li>
          <li>Audit logs, alerts, and SLA reports</li>
        </ul>
        <div className="work-tags">
          <span>React.js</span><span>Node.js</span>
          <span>PostgreSQL (pgAdmin)</span><span>AWS</span>
        </div>
      </article>

      {/* Case 3: Janta Prabhav – Dynamic Website */}
      <article className="work-card" data-aos="fade-up" data-aos-delay="160">
        <div className="work-badge">Media • News</div>
        <h3>Janta Prabhav — Dynamic News Website</h3>
        <p>
          A fast, dynamic news portal (similar to T9Marathi) with multi-author
          publishing, category pages, and strong SEO.
        </p>
        <ul className="work-points">
          <li>Editor-friendly CMS with drafts & scheduled posts</li>
          <li>Category, tag, and regional language routing</li>
          <li>Search, trending stories, and related posts</li>
          <li>SEO meta, sitemap, and social preview cards</li>
          <li>Ad slots, analytics, and CDN caching</li>
        </ul>
        <div className="work-tags">
          <span>React.js</span><span>Node.js</span>
          <span>PostgreSQL</span><span>AWS</span>
        </div>
      </article>
    </div>
  </div>
</section>


      {/* ============= FAQ ============= */}
      {/* <section className="faq-section" data-aos="fade-up">
        <div className="container">
          <h2 className="gradient-text">FAQs</h2>
          <div className="faq-list">
            <details>
              <summary>How fast can we start?</summary>
              <p>Discovery can start within 3–5 business days. Build usually begins the following sprint.</p>
            </details>
            <details>
              <summary>Do you sign NDAs and SLAs?</summary>
              <p>Yes—mutual NDA, IP assignment, and support SLAs are standard practice.</p>
            </details>
            <details>
              <summary>Which domains do you specialize in?</summary>
              <p>FinTech, HealthTech, Retail, and SaaS platforms—plus integrations with major clouds and payment gateways.</p>
            </details>
          </div>
        </div>
      </section> */}
      {/* ============= FAQ ============= */}
<section className="faq-section" data-aos="fade-up">
  <div className="container">
    <h2 className="gradient-text">FAQs</h2>
    <div className="faq-list">
      <details>
        <summary>How do you put customers first?</summary>
        <p>One owner for your project, weekly demos, and clear next steps. Your goals drive our roadmap—always.</p>
      </details>

      <details>
        <summary>How fast do you respond?</summary>
        <p>Urgent issues: immediate. High: same day. Normal: within 24 hours. You’ll always know who’s on it.</p>
      </details>

      <details>
        <summary>Will I understand what’s happening?</summary>
        <p>Yes—plain-English updates, no jargon. You get a short progress note, a demo link, and what’s next—every week.</p>
      </details>

      <details>
        <summary>Do I own everything you build?</summary>
        <p>100% yes. Code, designs, and data are yours. No vendor lock-in, ever.</p>
      </details>

      <details>
        <summary>Is my data safe?</summary>
        <p>We use secure logins, role-based access, audit logs, and encryption in transit and at rest. Only the right people see the right data.</p>
      </details>

      <details>
        <summary>What support do I get?</summary>
        <p>24/7 monitoring and on-call help. We fix critical issues first, then follow up with a simple report and prevention plan.</p>
      </details>

      <details>
        <summary>How do you handle changes?</summary>
        <p>Small tweaks: same sprint. Bigger changes: we estimate fast, get your OK, and adjust the plan—no surprises.</p>
      </details>
    </div>
  </div>
</section>

    </div>
  );
};

export default Home;
